"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _recipientAccount = require("../forms//recipient-account");
var _recipientVerify = require("../forms/recipient-verify");
var _review2 = require("../forms/review");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _emailVerify = _interopRequireDefault(require("../forms/email-verify"));
var _profileName = _interopRequireDefault(require("../forms/profile-name"));
var _profilePic = _interopRequireDefault(require("../forms/profile-pic"));
var _transactableModal = _interopRequireDefault(require("../modal/transactable-modal"));
var _helpers = require("../helpers/helpers");
var _analytics = _interopRequireDefault(require("./analytics"));
var _Info = _interopRequireDefault(require("../icons/Info"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _profile = require("../forms/profile");
var _reviews = require("../forms/reviews");
var _reactIntl = require("react-intl");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); } /* Forms, view components */
var Modal = _transactableModal.default.Modal;
/*Props -
- user
- intendedAction
- refreshAll
- hostFlag
*/
var Transactable = /*#__PURE__*/function (_React$Component) {
  _inherits(Transactable, _React$Component);
  function Transactable(props) {
    var _this;
    _classCallCheck(this, Transactable);
    _this = _callSuper(this, Transactable, [props]);
    _this.state = {
      ready_to_transact: null,
      transition_button: null,
      form_being_served: "",
      form_to_serve: null,
      reviews: null,
      has_reviews: null,
      total_number_of_tasks: 0,
      missing: null,
      on_task: 0,
      override_close_behavior: false
    };
    _this.findNextStateStatus = _this.findNextStateStatus.bind(_assertThisInitialized(_this));
    _this.setForm = _this.setForm.bind(_assertThisInitialized(_this));
    _this.moveAlong = _this.moveAlong.bind(_assertThisInitialized(_this));
    _this.onUpdateReview = _this.onUpdateReview.bind(_assertThisInitialized(_this));
    _this.onUpdateUser = _this.onUpdateUser.bind(_assertThisInitialized(_this));
    _this.onUpdateRecipient = _this.onUpdateRecipient.bind(_assertThisInitialized(_this));
    _this.onGetPendingReviews = _this.onGetPendingReviews.bind(_assertThisInitialized(_this));
    _this.onUserTransactReturn = _this.onUserTransactReturn.bind(_assertThisInitialized(_this));
    _this.onClickTransitionView = _this.onClickTransitionView.bind(_assertThisInitialized(_this));
    _this.intendedAction = _this.intendedAction.bind(_assertThisInitialized(_this));
    _this.transitionView = _this.transitionView.bind(_assertThisInitialized(_this));
    _this.closeBehavior = _this.closeBehavior.bind(_assertThisInitialized(_this));
    _this.handleSnoozeBtn = _this.handleSnoozeBtn.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(Transactable, [{
    key: "findNextStateStatus",
    value: function findNextStateStatus(returningFrom, data, textStatus, userUpdated) {
      var _this2 = this;
      //this creates a newState hash that clears and moves certain values along
      var newState = {};
      var arrayOfTasks = this.state.missing;
      var formIndexInTask = arrayOfTasks.indexOf(returningFrom);
      //we pop it out of the array
      arrayOfTasks.splice(formIndexInTask, 1);
      newState.missing = arrayOfTasks;
      newState.form_to_serve = null;
      var updateUserFn = function updateUserFn(userData) {
        if (_this2.props.actions) {
          _this2.props.actions.updateProfile(userData);
        }
      };
      switch (returningFrom) {
        case 'Avatar':
          //update user prop, top level
          updateUserFn(data);
          break;
        case 'Email Verification':
          //update user prop, top level

          break;
        case 'First Name':
          //update user prop, top level
          updateUserFn(data);
          break;
        case 'Last Name':
          //update user prop, top level
          updateUserFn(data);
          break;
        case 'Pending Reviews to Complete':
          //update reviewsArray, pop out old review;
          //data arg is reviewID
          // find reviewObj by reviewID && pop out of array
          var updatedReviewsArr,
            currentReviewsArray = this.state.reviews;
          var finishedReviewID = data;
          if (finishedReviewID === this.state.reviews[0]._id) {
            /* which it always should*/
            currentReviewsArray.shift();
          }
          updatedReviewsArr = currentReviewsArray;
          newState.reviews = updatedReviewsArr.length > 0 ? updatedReviewsArr : null;
          break;
        case 'Recipient Missing':
          break;
        case 'Recipient not Verified':
          break;
        default:
          break;
      }
      return newState;
    }

    /*this is where the functions are to get the piece of the flow */
  }, {
    key: "setForm",
    value: function setForm(whichForm, optionalNewStateHash, actualReviewObj) {
      var currentReviewNumber = optionalNewStateHash && optionalNewStateHash.hasOwnProperty('on_task') ? optionalNewStateHash.on_task : this.state.on_task + 1;
      var allForms = {
        'Avatar': /*#__PURE__*/_react.default.createElement(_profilePic.default, {
          user: this.props.user,
          updateAction: _profile.Profile.updateProfileInfo,
          callback: this.onUpdateUser
        }),
        'Email Verification': /*#__PURE__*/_react.default.createElement(_emailVerify.default, {
          user: this.props.user,
          componentWillMountAction: _profile.Profile.sendEmailVerificationCode,
          updateAction: _profile.Profile.submitVerificationCode,
          callback: this.onUpdateUser
        }),
        'First Name': /*#__PURE__*/_react.default.createElement(_profileName.default, {
          user: this.props.user,
          updateAction: _profile.Profile.updateProfileInfo,
          callback: this.onUpdateUser
        }),
        'Last Name': /*#__PURE__*/_react.default.createElement(_profileName.default, {
          user: this.props.user,
          updateAction: _profile.Profile.updateProfileInfo,
          callback: this.onUpdateUser
        }),
        'Pending Reviews to Complete': /*#__PURE__*/_react.default.createElement(_review2.ReviewForm, {
          review: actualReviewObj,
          user: this.props.user,
          currentReview: currentReviewNumber,
          totalReviews: this.state.total_number_of_tasks,
          cbAction: this.onUpdateReview,
          snoozable: this.props.snoozeFeature || false,
          handleSnoozeBtn: this.handleSnoozeBtn
        }),
        'Recipient Missing': /*#__PURE__*/_react.default.createElement(_recipientAccount.RecipientForm, {
          callback: this.onUpdateRecipient
        }),
        'Recipient not Verified': /*#__PURE__*/_react.default.createElement(_recipientVerify.TaxIDForm, {
          callback: this.onUpdateRecipient,
          user: this.props.user
        })
      };
      var formToServe = allForms[whichForm];
      if (optionalNewStateHash) {
        optionalNewStateHash.form_to_serve = formToServe;
        optionalNewStateHash.form_being_served = whichForm;
        this.setState(optionalNewStateHash);
      } else {
        this.setState({
          form_to_serve: formToServe,
          form_being_served: whichForm
        });
      }
    }
  }, {
    key: "moveAlong",
    value: function moveAlong(returningFrom, data, textStatus, userUpdated) {
      var snoozed = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var nextState = this.findNextStateStatus(returningFrom, data, textStatus, userUpdated);
      var transitionButton;
      var userFriendlyActions = {
        'Avatar': "profile pic",
        'Email Verification': "email verification code",
        'First Name': "name",
        'Last Name': "name",
        'Pending Reviews to Complete': "review",
        'Recipient Missing': "bank account",
        'Recipient not Verified': "tax ID",
        'final check': "final check"
      };
      transitionButton = this.transitionView(snoozed ? 'snooze request' : userFriendlyActions[returningFrom]);
      nextState.transition_button = transitionButton;
      this.setState(nextState);
    }
    /* end */
    /* ajax calls & callbacks */
  }, {
    key: "onUpdateReview",
    value: function onUpdateReview(reviewID) {
      return this.moveAlong(this.state.form_being_served, reviewID);
    }
  }, {
    key: "onUpdateUser",
    value: function onUpdateUser(response, textStatus, jqXHR) {
      if ("success" === textStatus) {
        return this.moveAlong(this.state.form_being_served, response.profile, textStatus, true);
      }
    }
  }, {
    key: "onUpdateRecipient",
    value: function onUpdateRecipient() {
      this.moveAlong(this.state.form_being_served);
    }
  }, {
    key: "onGetPendingReviews",
    value: function onGetPendingReviews(data, textStatus, xhrObj) {
      if ("success" === textStatus) {
        var reviews = data;
        var numberOfReviews = reviews.length;
        //'Pending Reviews to Complete'
        //depending on number of reviews, update task Missing Array so it's our one source of truth
        var taskArray = this.state.missing || [];
        var numberOfReviewsNotificationsToAdd = taskArray.length > 0 ? numberOfReviews - 1 : numberOfReviews;
        for (var thisRev = 0; thisRev < numberOfReviewsNotificationsToAdd; thisRev++) {
          taskArray.push('Pending Reviews to Complete');
        }
        var newState = {
          on_task: 0,
          reviews: reviews,
          missing: taskArray,
          total_number_of_tasks: taskArray.length
        };
        return this.setState(newState);
      }
    }
  }, {
    key: "onUserTransactReturn",
    value: function onUserTransactReturn(data, textStatus, jqXHR) {
      var newState = {};
      if ("error" === textStatus) {
        // TODO: error handling
      } else if (data.ready_to_transact) {
        // updates state to override default closeBehavior
        // to make sure request booking button is not enabled intermittently
        // when user is transactable
        this.setState({
          override_close_behavior: true
        });
        this.setState({
          ready_to_transact: data.ready_to_transact
        });
      } else {
        if (!data.ready_to_transact) {
          var hasReviews = false,
            firstNameIndex,
            lastNameIndex;
          newState.missing = data.missing;
          newState.ready_to_transact = data.ready_to_transact;
          if (analyticsIntegrations) {
            analyticsIntegrations.transactableViewed(data.missing);
          }
          for (var missing = 0; missing < data.missing.length; missing++) {
            //hardcoding this because I apparently can't get lodash to work
            if ("First Name" === data.missing[missing]) {
              firstNameIndex = missing;
            }
            if ("Last Name" === data.missing[missing]) {
              lastNameIndex = missing;
            }
            if ("Pending Reviews to Complete" === data.missing[missing]) {
              hasReviews = true;
            }
          }
          if (hasReviews) {
            newState.has_reviews = hasReviews;
          }
          //consolidate "first name" & "last name"
          if (undefined !== firstNameIndex && undefined !== lastNameIndex) {
            newState.missing.splice(firstNameIndex, 1);
          }
          // add in collecting the recipient account if missing
          var recipIndex = newState.missing.indexOf('Recipient not Verified');
          if (-1 !== recipIndex && !this.props.user.data.recipient_id) {
            var ndxForBankCollection = recipIndex - 1;
            newState.missing.splice(ndxForBankCollection, 0, 'Recipient Missing');
          }
          var totalNumberOfTasks = newState.missing.length;
          newState.total_number_of_tasks = totalNumberOfTasks;
          this.setState(newState);
        }
      }
    }
    /* end ajax call */
    /* Start Lifecycle */
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var SSOID = this.props.user.SSOid;
      Transactable.getUserStatus(SSOID, this.onUserTransactReturn, this.props.hostFlag, this.props.domain);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      //when we update user state?
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!this.state.ready_to_transact && this.state.has_reviews && null === this.state.reviews) {
        // this means that we need to go get those reviews before moving forward
        return _reviews.Reviews.getUserPendingReviewsWithSnooze(this.props.user.SSOid, this.onGetPendingReviews);
      }
      if (!this.state.ready_to_transact) {
        if (this.state.missing && 0 < this.state.missing.length) {
          if (!this.state.transition_button && !this.state.form_to_serve) {
            //because form_to_serve will set null upon return of successful form submission
            // read first missing task and apply it
            var nextFormName = this.state.missing[0];
            var onTaskNum = this.state.on_task + 1;
            var stateToUpdate = {};
            var review;
            stateToUpdate.on_task = onTaskNum;
            if ('Pending Reviews to Complete' === nextFormName) {
              var _this$props, _this$props$user;
              review = this.state.reviews[0];
              var SSOid = (_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$user = _this$props.user) === null || _this$props$user === void 0 ? void 0 : _this$props$user.SSOid;
              if (this.props.snoozeFeature && SSOid && review.host_id === SSOid) {
                var _review = review,
                  booking_id = _review.booking_id;
                _analytics.default.pendingReviewWithSnoozeViewed({
                  hostId: SSOid,
                  bookingId: booking_id
                });
              }
            }
            return this.setForm(nextFormName, stateToUpdate, review);
          }
        }
      }
    }
    /* End Lifecycle */
    /* Click Handler */
  }, {
    key: "onClickTransitionView",
    value: function onClickTransitionView(event) {
      event.preventDefault();
      if (this.state.missing && 0 === this.state.missing.length) {
        Transactable.getUserStatus(this.props.user.SSOid, this.onUserTransactReturn, this.props.hostFlag, this.props.domain);
      } else {
        var newState = {};
        newState.transition_button = null;
        this.setState(newState);
      }
    }
  }, {
    key: "intendedAction",
    value: function intendedAction(event) {
      var modalContainer = document.getElementById('modal-container');

      // unmount with React and kill modal
      _reactDom.default.unmountComponentAtNode(modalContainer);
      $(modalContainer).data('bs.modal', null);
      return this.props.intendedAction();
    }
    /* Views */
  }, {
    key: "transitionView",
    value: function transitionView(actionType) {
      var headerMargin = this.props.headerMargin;
      var helperText = /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "shared_components.transactable_main.transition_view_submitted",
        defaultMessage: "Your {actionType} was successfully submitted!",
        values: {
          actionType: actionType
        }
      });
      var btnName = this.state.missing && 0 < this.state.missing.length ? /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "shared_components.transactable_main.transition_view_next",
        defaultMessage: "Next"
      }) : /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "shared_components.transactable_main.transition_view_done",
        defaultMessage: "Done"
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12 text-center"
      }, /*#__PURE__*/_react.default.createElement("h3", {
        className: headerMargin || ''
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "shared_components.transactable_main.thank_you",
        defaultMessage: "Thank you"
      })), /*#__PURE__*/_react.default.createElement("p", null, helperText), /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-primary btn-lg col-xs-4 col-xs-offset-4",
        onClick: this.onClickTransitionView
      }, btnName));
    }
  }, {
    key: "closeBehavior",
    value: function closeBehavior() {
      // Method for handling when user clicks out of modal
      // and doesn't continue with filling out info.

      var override_close_behavior = this.state.override_close_behavior;
      if (this.props.closeBehavior && !override_close_behavior) {
        return this.props.closeBehavior();
      }
      return null;
    }
  }, {
    key: "handleSnoozeBtn",
    value: function handleSnoozeBtn(reviewId) {
      var _this3 = this;
      var ssoid, bookingId, count, deviceType;
      var _this$state$reviews = this.state.reviews,
        reviews = _this$state$reviews === void 0 ? [] : _this$state$reviews;
      if (reviews.length > 0) {
        var currentReview = reviews[0];
        bookingId = currentReview.booking_id;
        ssoid = currentReview.host_id;
        count = currentReview.times_skipped + 1 || 1;
        deviceType = _helpers.Helpers.isMobile() ? 'Mobile Web' : 'Web';
      }
      _reviews.Reviews.snoozePendingReview(reviewId, function () {
        _analytics.default.snoozeButtonPressed(count, deviceType, ssoid, bookingId);
        _this3.moveAlong(_this3.state.form_being_served, reviewId, null, null, true);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        _this$props2$snoozeFe = _this$props2.snoozeFeature,
        snoozeFeature = _this$props2$snoozeFe === void 0 ? false : _this$props2$snoozeFe,
        _this$props2$hostFlag = _this$props2.hostFlag,
        hostFlag = _this$props2$hostFlag === void 0 ? false : _this$props2$hostFlag;
      if (false === this.state.ready_to_transact) {
        var _this$props3, _this$props3$user;
        var modalBody;
        if (this.state.form_to_serve) {
          modalBody = this.state.form_to_serve;
        } else if (this.state.transition_button) {
          modalBody = this.state.transition_button;
        } else {
          modalBody = '';
        }
        var currentReview = this.state.reviews && this.state.reviews.length > 0 ? this.state.reviews[0] : undefined;
        var ssoid = (_this$props3 = this.props) === null || _this$props3 === void 0 ? void 0 : (_this$props3$user = _this$props3.user) === null || _this$props3$user === void 0 ? void 0 : _this$props3$user.SSOid;
        var guestId = currentReview === null || currentReview === void 0 ? void 0 : currentReview.guest_id;
        var currentReviewAsGuest = ssoid && guestId ? ssoid === guestId : false;
        var currentReviewSnoozeLimit = currentReview && currentReview.hasOwnProperty('allowed_to_skip') && !currentReview.allowed_to_skip;
        var banner = {
          type: 'graybg margin-lg-bottom',
          text: /*#__PURE__*/_react.default.createElement("h4", null, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
            id: "shared_components.transactable_main.banner_following",
            defaultMessage: "Before you can move forward, please complete the following."
          }))
        };
        var zenDeskLocale = this.props.zenDeskUrlLocale || 'en-us';
        var snoozeBanner = {
          type: 'creambg',
          text: /*#__PURE__*/_react.default.createElement("div", {
            className: "flex center middle"
          }, /*#__PURE__*/_react.default.createElement("span", {
            className: "info-banner"
          }, /*#__PURE__*/_react.default.createElement(_Info.default, null)), /*#__PURE__*/_react.default.createElement("p", {
            className: "text-left"
          }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
            id: "shared_components.transactable_main.banner_skip_limit_reached",
            defaultMessage: "This review has reached its snooze limit. Please complete or {contact}.",
            values: {
              contact: /*#__PURE__*/_react.default.createElement("a", {
                href: "https://support.peerspace.com/hc/".concat(zenDeskLocale),
                target: "_blank",
                rel: "noreferrer noopener"
              }, "contact support for help")
            }
          })))
        };
        var addCloseIcon;
        var showBanner;
        var whichBanner;
        if (!snoozeFeature) {
          addCloseIcon = true;
          showBanner = true;
          whichBanner = banner;
        } else {
          addCloseIcon = !hostFlag || currentReviewAsGuest || this.state.transition_button;
          if (this.state.transition_button || currentReviewAsGuest) {
            showBanner = true;
          } else {
            showBanner = currentReviewSnoozeLimit;
          }
          whichBanner = this.state.transition_button || currentReviewAsGuest ? banner : snoozeBanner;
        }
        return /*#__PURE__*/_react.default.createElement(Modal, {
          addCloseIcon: addCloseIcon,
          modalID: "transactable-modal",
          closeBehavior: this.closeBehavior,
          body: modalBody,
          show: true,
          modalSize: "lg-size",
          modalType: "trans",
          showBanner: showBanner,
          banner: whichBanner
        });
      } else {
        return /*#__PURE__*/_react.default.createElement(Modal, {
          show: false,
          modalID: "transactable-modal",
          closeBehavior: this.intendedAction,
          modalSize: "lg-size",
          modalType: "trans"
        });
      }
    }
  }], [{
    key: "getUserStatus",
    value: function getUserStatus(SSOID, callback, hostFlag, domainPath) {
      var hostFlagString = hostFlag ? '?receive=true' : '';
      var path = domainPath ? "/".concat(domainPath) : '';
      var url = "/v1/profiles/".concat(SSOID, "/status/transact").concat(path).concat(hostFlagString);
      var accessToken = PSSessions.Cookies('PSAccess');
      var sendOptions = {
        context: this,
        cache: false,
        type: 'GET',
        url: url,
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json'
        }
      };
      $.ajax(sendOptions).done(function (res, textStatus, jqXHR) {
        return callback(res, textStatus, jqXHR);
      });
    }
  }, {
    key: "updateUserInfo",
    value: function updateUserInfo(profile, refreshAll) {
      _reactDom.default.render( /*#__PURE__*/_react.default.createElement(Transactable, {
        user: profile,
        refreshAll: refreshAll
      }), document.getElementById('modal-container'));
    }
  }]);
  return Transactable;
}(_react.default.Component);
Transactable.propTypes = {
  headerMargin: _propTypes.default.string,
  snoozable: _propTypes.default.bool,
  hostFlag: _propTypes.default.bool,
  snoozeFeature: _propTypes.default.bool
};
var _default = exports.default = Transactable;